import React, { useState } from "react";

// Package Import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

// User Import

import { updateSchema } from "../../../../Services/validations/AdminPortal/UpdatePassword";
import { headersPost } from "../../../../Services/API";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";

//constants

const initialValue = {
  old_password: "",
  new_password: "",
  confirm_new_password: "",
};

// Component

const Changepassword = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  // form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      user: {
        oldpassword: values?.old_password,
        password: values?.new_password,
      },
    };
    setOpen(true);

    headersPost(MINISTRY_API_ULRS.UPDATE_PASSWORD, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setTimeout(() => {
            navigate(-1);
          }, 100);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Render

  return (
    <Paper
      sx={{ p: 2, margin: "auto", maxWidth: 400, flexGrow: 1, borderRadius: 2 }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"center"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Change Password
        </Typography>
        <Formik
          initialValues={initialValue}
          onSubmit={formSubmitHanlder}
          validationSchema={updateSchema}
        >
          {({ values, touched, errors, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit} noValidate>
              <Box padding={{ xs: 2, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                  maxWidth={250}
                >
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Enter Current Password"
                      type={"password"}
                      name="old_password"
                      onChange={handleChange}
                      error={
                        touched?.old_password && Boolean(errors?.old_password)
                      }
                      helperText={touched?.old_password && errors?.old_password}
                      value={values.old_password}
                      fullWidth
                      sx={{
                        [`.${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                          backgroundColor: `${theme.palette.secondary.dark}`,
                        },
                        [`.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      fullWidth
                      placeholder="Enter new Password"
                      type={"password"}
                      name="new_password"
                      onChange={handleChange}
                      error={
                        touched?.new_password && Boolean(errors?.new_password)
                      }
                      helperText={touched?.new_password && errors?.new_password}
                      value={values.new_password}
                      sx={{
                        [`.${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                          backgroundColor: `${theme.palette.secondary.dark}`,
                        },
                        [`.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>

                  <Grid container>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Confirm Password"
                      type={"password"}
                      name="confirm_new_password"
                      onChange={handleChange}
                      error={
                        touched?.confirm_new_password &&
                        Boolean(errors?.confirm_new_password)
                      }
                      helperText={
                        touched?.confirm_new_password &&
                        errors?.confirm_new_password
                      }
                      value={values.confirm_new_password}
                      fullWidth
                      sx={{
                        [`.${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                          backgroundColor: `${theme.palette.secondary.dark}`,
                        },
                        [`.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                    <Grid
                      container
                      marginTop={5}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          borderRadius: theme.spacing(1),
                          minWidth: "20%",
                        }}
                      >
                        Change Password
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default Changepassword;
